import styled from "styled-components";
import { setPosition, setFlex } from "../variables/utils";
import { BREAKPOINTS, desktop, mobile } from "../variables/breakpoints";

export const TileWrapper = styled.div`
  ${setFlex({ justify: "flex-end" })};
  min-height: 100vh;
  height: 100%;
  width: 100%;
  padding-top: 150vh;
  padding-bottom: 150vh;

  @media (max-width: ${BREAKPOINTS.sm}px) {
    ${setFlex({ align: "center" })};
    width: auto;
    padding-top: ${props => (props.$maxPadding ? "150vh" : "100vh")};
  }
`;

export const TileComponentContainer = styled.div`
  ${setPosition({ position: "relative" })};
  ${setFlex({ justify: "flex-end" })};
  max-width: 80vw;
  width: 100%;
  flex-wrap: wrap;
  height: fit-content;

  @media (max-width: ${BREAKPOINTS.sm}px) {
    max-width: 100%;
  }
`;

export const TileContainer = styled.div`
  ${setPosition({ position: "relative" })};
  ${setFlex({ justify: "center" })};
  height: fit-content;
  padding: 2rem;

  ${props => props.$customStyles && props.$customStyles};
  ${props => props.$minWidth && "min-width: calc(100% / 3)"};
  ${props =>
    props.$maxWidth &&
    `
    max-width: 30vw;
      @media (max-width: ${BREAKPOINTS.sm}px) {
        max-width: 100%;
      }
    `};
  @media (max-width: ${BREAKPOINTS.sm}px) {
    ${setFlex({ align: "center" })};
    width: auto;
  }

  @media (max-width: ${BREAKPOINTS.sm}px) {
    max-width: 100%;
  }
`;

export const TileImage = styled.img`
  max-width: 100%;
  padding: 1rem;
  ${props => props.$desktop && desktop};
  ${props => props.$mobile && mobile};

  @media (max-width: ${BREAKPOINTS.sm}px) {
    width: 100%;
    padding: 0;
  }
`;

export const TileLink = styled.a`
  height: fit-content;
  width: fit-content;
  cursor: pointer;
`;

export const TileImageWrap = styled.div`
  ${setPosition({ position: "relative" })};
  ${setFlex({ justify: "flex-end" })};
  width: 100%;

  @media (max-width: ${BREAKPOINTS.sm}px) {
    ${setFlex({ direction: "column" })};
  }
`;

export const VideoContainer = styled.div`
  width: 100%;
  height: 100%;

  .plyr__controls {
    display: none;
  }
`;

export const ProductContainer = styled.div`
  ${setPosition({ position: "relative" })};
  height: inherit;
  width: min-content;
  min-width: calc(100% / 3);
  @media (max-width: ${BREAKPOINTS.sm}px) {
    ${setFlex({ align: "center", justify: "center" })};
    width: auto;
    padding: 1.5rem;
  }
  ${props => props.$cursor && "cursor: pointer"};
  ${props => props.$customStyles && props.$customStyles};
`;

export const ProductImages = styled.div`
  ${setPosition({ position: "relative" })};
  height: auto;
  width: fit-content;
  pointer-events: none;
`;

export const ProductDisplayImage = styled.img`
  height: inherit;
  transition: opacity 0.5s ease-in-out;
`;

export const ProductHoverImage = styled.div`
  ${setFlex({})};
  ${setPosition({ position: "absolute", top: "0", left: "0" })};
  width: 100%;
  height: 100%;
  overflow: hidden;
`;

export const ProductSection = styled.div`
  height: 100%;
  float: left;
`;
